import { render, staticRenderFns } from "./GerarBoletoDialog.vue?vue&type=template&id=672958c7&"
import script from "./GerarBoletoDialog.vue?vue&type=script&lang=js&"
export * from "./GerarBoletoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports